import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import * as Icons from 'components/Utils/Icons'

const TAB = 'Tab'
const DOWN = 'ArrowDown'
const UP = 'ArrowUp'

export default function SearchBox({
  value,
  onChange,
  inputRef,
  onFocusFirstRow,
  onFocusLastRow,
}) {
  const onInputChange = React.useCallback(
    event => onChange(event.target.value),
    [onChange]
  )

  const onKeyDown = React.useCallback(
    event => {
      const cursorAtEnd =
        event.target.selectionStart === event.target.value.length
      if (
        cursorAtEnd &&
        (event.key === DOWN || (event.key === TAB && !event.shiftKey))
      ) {
        onFocusFirstRow()
        return
      }

      const cursorAtStart = event.target.selectionStart === 0
      if (
        cursorAtStart &&
        (event.key === UP || (event.key === TAB && event.shiftKey))
      ) {
        onFocusLastRow()
      }
    },
    [onFocusFirstRow, onFocusLastRow]
  )

  return (
    <div className="flexbox flexbox-align-center border-bottom-small border-shade-40 padding-left-small padding-right-normal">
      <Icons.SearchIcon
        size={12}
        className="flexbox-no-grow shade-30 margin-left-small"
      />
      <input
        type="text"
        className={classNames(
          [
            'flexbox-grow',
            'width-full border-none',
            'padding-vertical-normal padding-left-medium',
            'font-size-normal font-weight-medium',
            'background-transparent',
            'placeholder-shade-30 shade-05',
          ],
          {}
        )}
        ref={inputRef}
        autoFocus
        tabIndex={-1}
        placeholder={'Find a channel...'}
        onChange={onInputChange}
        onKeyDown={onKeyDown}
        value={value}
      />
    </div>
  )
}

SearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  inputRef: PropTypes.any,
  onFocusFirstRow: PropTypes.func.isRequired,
  onFocusLastRow: PropTypes.func.isRequired,
}
